<div class="title">{{ title }}</div>
<div class="form-wrapper-full-auto">
  <div class="form-label">
    {{ 'msg.user.rawmaterial.import.file-to-import' | translate}} *
  </div>
  <div class="form-input-div">
    <input pInputText 
      type="text" class="form-input" 
      [ngClass]="{ 'error-input': !isValidFile && showError }"
      (click)="fileInput.click()" readonly [ngModel]="fileName"/>
    <input pInput type="file" (change)="onFileSelection($event)" accept=".csv" #fileInput hidden />
  </div>
  <small class="error-msg">
    {{ fileErrorMessage }}
  </small>

  <div class="form-label">
    {{ 'label.user.export.popin.list.export-format' | translate}}
  </div>
  <div class="form-input-div">
    <mat-form-field class="form-input">
      <mat-select [(ngModel)]="selectedFormat">
        <mat-option *ngFor="let format of listFormat" [value]="format">
          {{format | translate }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>
<div class="asi-container" fxLayout="row" fxLayoutAlign="center center">
  <button
    pButton
    class="neq-primeng-button-text"
    (click)="launchImport()"
    label="{{'label.common.import' | translate}}"></button>
  <button
    pButton
    class="neq-primeng-button-text"
    (click)="close()"
    label="{{'msg.common.validation.cancel' | translate}}"></button>
</div>